/*
 * @Author: xuning 1373543909@qq.com
 * @Date: 2024-03-08 10:06:22
 * @LastEditors: xuning 1373543909@qq.com
 * @LastEditTime: 2024-04-01 08:52:00
 * @FilePath: \car-companies-front\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios'
const service = axios.create({
  // baseURL:'http://192.168.0.122:9999/admin/',
  baseURL:'/admin/',
  timeout: 10000 // request timeout
})

service.interceptors.request.use(
  config => {
    // console.log(config)
      // config.headers['Authorization'] = 'Bearer ' +access_token
    return config
  },
  error => {
    // console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    let isBlob = response.data instanceof Blob
    // 导出接口
    if (!isBlob) {
      if (res.code !== 0) {
        // Message({
        //   message: res.msg || 'Error！服务器接口发生错误！',
        //   type: 'error',
        //   duration: 3 * 1000,
        //   showClose: true
        // })
        return Promise.reject(new Error(res.message || 'Error'))
      } else {
        // code为0正常通过
        return res
      }
    } else {
      return res
    }
  },
  error => {
    if (error.response) {
      // 获取状态码
      const status = error.response.status;
      if (status === 424){
        // MessageBox.confirm('您的token已过期, 您可以离开当前页面重新登录', '确定退出登录', {
        //   confirmButtonText: '重新登录',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
        //   store.dispatch('user/logout')
        // })
      }else {
        console.log('状态码500：', error.response.data);
        // 可以根据需要执行相应的操作，例如重定向到错误页面、显示错误消息等
        const data = error.response.data;
        if (data.code == undefined) {
          // Message({
          //   message: '服务异常，请排查网络或联系管理员解决！',
          //   type: 'error',
          //   duration: 3 * 1000,
          //   showClose: true
          // })
          return
        }
        // Message({
        //   message: '错误信息：' + data.msg,
        //   type: 'error',
        //   duration: 3 * 1000,
        //   showClose: true
        // })
      }
    }
    return Promise.reject(error)
  }
)

export default service
